import './App.css';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './containers/Home';
import Footer from './components/Footer';
import ProductsContainer from './containers/ProductsContainer';
import ProductDetailContainer from './containers/ProductDetailContainer';
import BudgetContainer from './containers/BudgetContainer';
import AdvicesContainer from './containers/AdvicesContainer';
import AdviceDetailContainer from './containers/AdviceDetailContainer';
import NotFoundContainer from './containers/NotFoundContainer';
import MiscellaneousContainer from './containers/MiscellaneousContainer';
import MiscDetailContainer from './containers/MiscDetailContainer';
import WhatsappButton from './components/WhatsappButton';

function App() {
  return <BrowserRouter>
    <Navbar />
    <Switch>
      <Route exact path="/">
        <Home/>
      </Route>
      <Route exact path="/productos">
        <ProductsContainer/>
      </Route>
      <Route path="/productos/:id">
        <ProductDetailContainer/>
      </Route>
      <Route path="/solicitar-presupuesto">
        <BudgetContainer />
      </Route>
      <Route exact path="/consejos">
        <AdvicesContainer />
      </Route>
      <Route exact path="/consejos/:adviceId">
        <AdviceDetailContainer />       
      </Route>
      <Route exact path="/varios">
        <MiscellaneousContainer/>
      </Route>
      <Route exact path="/varios/:miscId">
        <MiscDetailContainer/>
      </Route>
      <Route path="/no-encontrado">
        <NotFoundContainer/>
      </Route>
      <Route>
        <Home/>
      </Route>
    </Switch>
    <Footer />
    <WhatsappButton />
  </BrowserRouter>
}

export default App;
